import { db } from '../../../firebase/firebase'
import { dispatchConnectedEvents, dispatchConfirmedEvents } from '../../../actions/adminEvents'
import _ from  'lodash'
const connectedEventsRef = db.ref('/connectedEvents')
const confirmedEventsRef = db.ref('/confirmedEvent')

export const connectedEventsListener = (sw) => {
    if(sw==='on'){
        connectedEventsRef.on('value', async (snap)=> {
            if(!snap.exists())return null
            const connectedEvents = await snap.val()
            const conEventsArr = await _.values(connectedEvents)
            return dispatchConnectedEvents(conEventsArr)
        })
    } else {
        return connectedEventsRef.off('value')
    }
}

export const confirmedEventsListener = async (sw) => {
    if(sw==='on'){
        confirmedEventsRef.on('value', async (snap)=> {
            if(await snap.exists()) {
                const confirmedEvents = await snap.val()
                const conEventsArr = await _.values(confirmedEvents)
                return dispatchConfirmedEvents(conEventsArr)
            }
        })
    } else {
        return confirmedEventsRef.off('value')
    }

}


// WEBPACK FOOTER //
// ./src/Components/Admin/AdminEvents/adminEventsAPI.js